import { z } from 'zod'

export const sessionUserSchema = z.object({
  username: z.string(),
  email: z.string().nullable(),
  status: z.string(),
  enabled: z.boolean(),
})
export type SessionUser = z.infer<typeof sessionUserSchema>

export const sessionsResponseSchema = z.object({
  users: z.array(sessionUserSchema),
})
export type SessionsResponse = z.infer<typeof sessionsResponseSchema>

export const signOutResponseSchema = z.object({
  ok: z.boolean(),
})
export type SignOutResponse = z.infer<typeof signOutResponseSchema>
